import Phaser from 'phaser';

const SKY_TOP = 0x0a0612;
const SKY_BOT = 0x2e1055;
const EARTH_BLUE = 0x3b82f6;
const EARTH_GREEN = 0x22c55e;
const PALACE = 0x4b5563;
const PALACE_DEEP = 0x1f2937;
const PALACE_RED = 0xef4444;
const MOON_SURFACE = 0x9ca3af;
const MOON_DEEP = 0x6b7280;

export function drawMoonPalaceSkyBackground(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  g.clear();
  const step = Math.max(1, Math.floor(h / 48));
  for (let y = 0; y < h; y += step) {
    const t = y / h;
    const r = lerp((SKY_TOP >> 16) & 0xff, (SKY_BOT >> 16) & 0xff, t);
    const gC = lerp((SKY_TOP >> 8) & 0xff, (SKY_BOT >> 8) & 0xff, t);
    const b = lerp(SKY_TOP & 0xff, SKY_BOT & 0xff, t);
    g.fillStyle((r << 16) | (gC << 8) | b, 1);
    g.fillRect(0, y, w, step + 1);
  }

  let seed = 2026;
  const rand = () => {
    seed = (seed + 0x6d2b79f5) >>> 0;
    let t = seed;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  for (let i = 0; i < 110; i++) {
    const sx = rand() * w;
    const sy = rand() * h * 0.75;
    const bright = rand();
    g.fillStyle(bright < 0.1 ? 0xfde047 : 0xffffff, 0.4 + rand() * 0.6);
    g.fillRect(sx, sy, bright < 0.05 ? 2 : 1, bright < 0.05 ? 2 : 1);
  }

  const earthX = Math.floor(w * 0.8);
  const earthY = Math.floor(h * 0.18);
  const earthR = 28;
  g.fillStyle(EARTH_BLUE, 1);
  g.fillCircle(earthX, earthY, earthR);
  g.fillStyle(EARTH_GREEN, 1);
  g.fillEllipse(earthX - 6, earthY + 2, 18, 10);
  g.fillEllipse(earthX + 10, earthY - 6, 12, 8);
  g.fillStyle(0xffffff, 0.3);
  g.fillCircle(earthX - earthR * 0.3, earthY - earthR * 0.3, earthR * 0.2);
}

export function drawMoonPalaceSilhouette(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  const baselineY = Math.floor(h * 0.72);

  g.fillStyle(MOON_SURFACE, 1);
  g.fillRect(0, baselineY, w, h - baselineY);

  g.fillStyle(MOON_DEEP, 0.6);
  for (let i = 0; i < 16; i++) {
    const cx = (i / 16) * w + Math.floor(Math.random() * 20);
    const cy = baselineY + 15 + (i % 3) * 20;
    g.fillCircle(cx, cy, 8 + (i % 4));
  }

  const cx = Math.floor(w * 0.5);
  const baseY = baselineY;
  const palaceH = Math.floor(h * 0.32);

  g.fillStyle(PALACE_DEEP, 1);
  g.fillRect(cx - 120, baseY - palaceH, 240, palaceH);

  g.fillStyle(PALACE, 1);
  g.fillTriangle(cx - 140, baseY - palaceH, cx - 80, baseY - palaceH - 40, cx - 40, baseY - palaceH);
  g.fillTriangle(cx - 40, baseY - palaceH, cx, baseY - palaceH - 60, cx + 40, baseY - palaceH);
  g.fillTriangle(cx + 40, baseY - palaceH, cx + 80, baseY - palaceH - 40, cx + 140, baseY - palaceH);

  g.fillStyle(PALACE_RED, 1);
  g.fillRect(cx - 20, baseY - palaceH + 40, 40, 60);
  g.fillStyle(0x0a0f1f, 1);
  g.fillRect(cx - 15, baseY - palaceH + 50, 30, 45);
  g.fillStyle(PALACE_RED, 0.4);
  g.fillCircle(cx - 100, baseY - palaceH + 20, 6);
  g.fillCircle(cx + 100, baseY - palaceH + 20, 6);
  g.fillStyle(PALACE_RED, 1);
  g.fillCircle(cx - 100, baseY - palaceH + 20, 3);
  g.fillCircle(cx + 100, baseY - palaceH + 20, 3);

  g.fillStyle(PALACE_DEEP, 1);
  for (let i = 0; i < 5; i++) {
    const spireX = cx - 100 + i * 50;
    g.fillRect(spireX, baseY - palaceH + 4, 4, 12);
  }
}

function lerp(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}
